import { useFadeIn } from '@/hooks/useFadeIn';

const features = [
  {
    title: 'カウンセリング無料',
    desc: '治療の可否・改善度・費用を事前にご説明します。',
  },
  {
    title: '当日施術も対応',
    desc: 'カウンセリング後、ご希望があれば即日対応も可能です。',
  },
  {
    title: '矯正との組み合わせも可能',
    desc: '矯正装置除去後のホワイトスポットにも対応しています。',
  },
];

interface FeatureCardProps {
  title: string;
  desc: string;
  delay: number;
}

function FeatureCard({ title, desc, delay }: FeatureCardProps) {
  const fade = useFadeIn({ direction: 'up', delay });
  return (
    <div
      ref={fade.ref}
      style={fade.style}
      className="bg-white rounded-lg border-t border-gray-200 p-5 md:p-6"
    >
      <h3 className="font-medium text-gray-900 text-sm md:text-base mb-2">{title}</h3>
      <p className="font-light text-gray-700 text-sm leading-loose">{desc}</p>
    </div>
  );
}

export default function IconPricing() {
  const heading = useFadeIn({ direction: 'up' });
  const left = useFadeIn({ direction: 'up', delay: 100 });
  const cta = useFadeIn({ direction: 'up', delay: 300 });

  return (
    <section id="pricing" className="bg-white py-14 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div ref={heading.ref} style={heading.style}>
          <span
            className="inline-block font-medium text-xs md:text-sm tracking-[0.2em]"
            style={{ color: '#3E5F8F' }}
          >
            Pricing
          </span>
          <div className="w-8 h-px mt-3 mb-4" style={{ backgroundColor: '#3E5F8F' }}></div>
          <h2 className="font-serif text-gray-900 text-2xl md:text-3xl leading-relaxed mb-8 md:mb-10">
            料金について
          </h2>
        </div>

        <div className="bg-gray-50 rounded-lg border border-gray-200 p-6 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            <div className="w-full lg:w-1/2">
              <div ref={left.ref} style={left.style}>
                <span className="font-light text-gray-500 text-xs md:text-sm tracking-wide">
                  ICON 白斑治療 / 1歯あたり
                </span>
                <div className="mt-3 mb-2">
                  <span className="font-serif text-gray-900 text-4xl md:text-5xl">¥33,000</span>
                  <span className="font-light text-gray-700 text-sm ml-1">（税込）</span>
                </div>
                <span className="font-light text-gray-500 text-xs">自由診療 / 1歯ごとの料金</span>
                <p className="font-light text-gray-700 text-sm leading-loose mt-5">
                  白斑の範囲・深さ・対象となる歯の本数によって<br />
                  合計金額が異なります。<br />
                  まずは無料カウンセリングで口腔内を確認し、<br />
                  正確な費用と改善度の目安をご案内します。
                </p>
              </div>
            </div>

            <div className="w-full lg:w-1/2">
              <div className="grid grid-cols-1 gap-4">
                {features.map((f, i) => (
                  <FeatureCard key={f.title} title={f.title} desc={f.desc} delay={200 + i * 80} />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div ref={cta.ref} style={cta.style} className="text-center mt-10 md:mt-12">
          <a
            href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center text-white font-medium text-base px-8 py-4 rounded-full whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity duration-200"
            style={{ backgroundColor: '#3E5F8F' }}
          >
            無料カウンセリングを予約する
          </a>
          <p className="font-light text-gray-500 text-xs mt-3">WEB予約は24時間受付中</p>
        </div>
      </div>
    </section>
  );
}